import type { TxOverview } from '../logic/createTxOverview'
import { Token } from '@/domain/types/Token'
import { formatTargetDate } from '@/features/spk/staking/utils/formatTargetDate'
import { TransactionOverview } from '@/ui/organisms/transaction-overview/TransactionOverview'
import { testIds } from '@/ui/utils/testIds'

interface StakeTransactionOverviewProps {
  txOverview: TxOverview
  selectedToken: Token
}

function StakeTransactionOverview({ txOverview }: StakeTransactionOverviewProps) {
  if (txOverview.status !== 'success') {
    const placeholder = '-'

    return (
      <TransactionOverview>
        <TransactionOverview.Row>
          <TransactionOverview.Label>Claimable on</TransactionOverview.Label>
          <TransactionOverview.Generic>{placeholder}</TransactionOverview.Generic>
        </TransactionOverview.Row>
      </TransactionOverview>
    )
  }
  const { claimableOn } = txOverview

  return (
    <TransactionOverview>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Claimable on</TransactionOverview.Label>
        <TransactionOverview.Generic data-testid={testIds.spkStaking.unstakeDialog.transactionOverview.claimableOn}>
          {formatTargetDate(claimableOn)}
        </TransactionOverview.Generic>
      </TransactionOverview.Row>
    </TransactionOverview>
  )
}

export {
  StakeTransactionOverview as TransactionOverview,
  type StakeTransactionOverviewProps as TransactionOverviewProps,
}
